module.exports = __webpack_public_path__ + "img/speech_8.fd031ac6.jpeg";